import App from './kmastra'
import main from '@shared/main';

main.CreateApp(App);